import { Modal } from "flowbite-react";
import { useContext, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import CampaignContext from "../../../contexts/CampaignContext";
import UserContext from "../../../contexts/UserContext";
import restService from "../../../restService";
import DrawManagement from "./DrawManagement";
import LeaderboardPage from "./leaderboard";
import Tabs from "./tabs";
import Transactions from "./transactions";

const Records = () => {
  const [campaign] = useContext(CampaignContext);
  const [user] = useContext(UserContext);
  const [searchParams, setSearchParams] = useSearchParams();

  const [rewards, setRewards] = useState([]);

  const tabs = ["Transactions", "Entries Management", "Leaderboard"];
  const activeTab = searchParams.get("tab") || "Transactions";
  const [entriesExported, setEntriesExported] = useState(false);

  useEffect(() => {
    fetchCampaignRewards();
  }, []);

  const fetchCampaignRewards = async () => {
    try {
      const { data } = await restService.Configs.getRewardPackages(
        campaign?.id
      );

      setRewards(data);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div>
      <div>
        <h1 className="text-2xl leading-9 font-[600]">Entries</h1>
      </div>

      <Tabs
        tabs={tabs}
        activeTab={activeTab}
        setActiveTab={(value) => {
          setSearchParams({ tab: value }, { replace: true });
        }}
      />

      {activeTab === "Transactions" ? (
        <Transactions />
      ) : activeTab === "Entries Management" ? (
        <DrawManagement rewardTypes={rewards} />
      ) : (
        <LeaderboardPage />
      )}

      <Modal
        show={entriesExported}
        dismissible={true}
        size="lg"
        placement="top-center"
        onClose={() => {
          setEntriesExported(false);
        }}
        className="!items-start"
      >
        <div className="flex w-full items-end justify-end px-6 py-4">
          <button
            onClick={() => {
              setEntriesExported(false);
            }}
            className="h-4 w-4 rounded-full hover:bg-[#f7f7f7]"
          >
            X
          </button>
        </div>
        <div className="px-6 pb-6 flex flex-col items-center text-center gap-4 justify-center">
          <p>
            Transactions file has been sent to{" "}
            <span className="font-semibold">{user?.email}</span>
          </p>
          <p>Kindly check your email.</p>
        </div>
      </Modal>
    </div>
  );
};

export default Records;
